import axios from "axios";

// Set base URL - use relative URL in development to leverage proxy
// In production, use the full URL from environment variable
if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
} else {
  // In development, use relative URL to work with proxy
  axios.defaults.baseURL = '/api/';
}

// Request interceptor to add Authorization header to all requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    // Add Authorization header if token exists
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add common headers to prevent CORS issues
    config.headers['Accept'] = config.headers['Accept'] || 'application/json';

    // For non-FormData requests, set Content-Type to application/json
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors globally
    if (
      error?.response?.status === 401 &&
      error?.response?.data?.message === "Unauthenticated."
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("is_authenticated");

      if (window.location.pathname !== "/login") {
        window.location.href = "/#/login";
      }
    }

    return Promise.reject(error);
  }
);

export default axios;
